import React, { useEffect, useState } from "react";
import { Html5QrcodeScanner } from "html5-qrcode";
import Select from "react-select";
import { Dots } from "react-activity";
import * as url from "../../helpers/url_helper";
import { setBreadcrumbItems } from "../../store/actions";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import logoVSP from "../../assets/images/VUF-Logo-curve.svg";
import VUF_TEMP from "../../assets/images/VUF_temple.jpg";
import TEMP from "../../assets/images/temple.jpg";
import Spinners from "components/Common/Spinner";
import "../../assets/attendance.css";

const ScheduleAttendance = (props) => {
  const { id } = useParams();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showMessage, setShowMessage] = useState("");
  const [eventId, setEventID] = useState("");
  const [VUFID, setVUFID] = useState(null);
  const [mode, setMode] = useState(null);
  const [attendanceStatus, setAttendanceStatus] = useState(true);
  const [username, setUserName] = useState(null);
  const [usertime, setUserTime] = useState(null);

  useEffect(() => {
    setEventID(id);
    const scanner = new Html5QrcodeScanner("reader", {
      qrbox: {
        width: 300,
        height: 300,
      },
      rememberLastUsedCamera: true,
      disableFlip: true,
      fps: 5,
      showQrCodeReticle: true,
    });

    scanner.render(success, error);

    function success(result) {
      scanner.clear();
      setResult(result);
      setLoading(true);
      onScanned("QR", result);
    }
    function error(err) {
      // console.log(err)
    }
  }, []);

  function scanAgain() {
    window.location.reload();
  }

  async function onScanned(mode, vufId = null) {
    setMode(mode);
    if (vufId != null) {
      setVUFID(vufId);
    }

    if (id != "") {
      setResult("success");
      setLoading(true);
      const Body = JSON.stringify({
        mode: mode,
        VUFID: vufId,
      });

      let urlPath = `schedule/schedule-attendance/${id}`;

      fetch(url.VUF_APP_API + urlPath, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: Body,
      })
        .then((response) => response.json())
        .then((responseData) => {
          setTimeout(() => {
            setLoading(false);
          }, 1000);
          if (responseData.status || responseData.response) {
            var resdata = responseData.response;
            setUserName(
              resdata.userId.firstName + " " + resdata.userId.lastName
            );
            setUserTime(resdata.time);
            setAttendanceStatus(true);
          } else {
            setAttendanceStatus(false);
          }
        })
        .catch((error) => {
          // // console.log("err", error);
        })
        .finally((final) => {
          setLoading(false);
        });
    }
  }

  let divImage = VUF_TEMP;

  return (
    <>
      <React.Fragment>
        {loading ? (
          <Spinners />
        ) : (
          <div>
            <header className="header">
              <img src={logoVSP} alt="Vishv Umiya Logo" className="logo" />
              <h1>Schedule Attendance</h1>
            </header>
            <div
              className="banner"
              style={{ backgroundImage: "url(" + divImage + ")" }}
            ></div>
            <div className="container mt-4">
              <div className="card shadow-sm p-4">
                {/* Submit Button */}
                <div className="text-center mb-4">
                  <button
                    type="button"
                    className="btn btn-primary px-4"
                    onClick={(event) => onScanned("mobile")}
                  >
                    User for meeting
                  </button>
                </div>

                {/* QR Scanner */}
                <div className="col-md-12 text-center">
                  {result ? (
                    <>
                      <div className="row">
                        <div className="col-lg-12">
                          <label
                            style={{
                              textAlign: "center",
                              width: "100%",
                              fontSize: 18,
                              fontWeight: 700,
                              color: "#363535",
                              marginTop: 20,
                              marginBottom: 20,
                            }}
                          >
                            {showMessage}
                          </label>
                        </div>
                      </div>
                      {attendanceStatus ? (
                        <div id="attendance-success-container">
                          <div className="success-card">
                            <div className="checkmark-circle">
                              <div className="checkmark-stem"></div>
                              <div className="checkmark-kick"></div>
                            </div>
                            <h2 id="success-message">
                              Attendance Recorded Successfully!
                            </h2>
                            <p id="time-message">Time: {usertime}</p>
                            <p id="user-info">Welcome, {username}</p>
                          </div>
                        </div>
                      ) : (
                        <div id="attendance-success-container">
                          <div className="success-card">
                            <div className="checkmark-circle">
                              <div className="checkmark-stem"></div>
                              <div className="checkmark-kick"></div>
                            </div>
                            <h2 id="success-message">
                              You are Already Attended
                            </h2>
                          </div>
                        </div>
                      )}
                      <div className="row">
                        <div className="col-lg-12 mt-5">
                          <button
                            type="button"
                            className="btn btn-outline-primary mr-2"
                            onClick={scanAgain}
                          >
                            <i className="fa fa-history me-1"></i>Scan Again
                          </button>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div style={{ flex: 1 }} id="reader"></div>
                  )}
                </div>
              </div>
            </div>
            <div style={{ marginLeft: "80%" }}>
              <img src={TEMP} alt="Temple Image" className="temple-image" />
            </div>
            <div className="reg-footer">
              <p className="iso">ISO 9001:2015 Approval Number: 00044220</p>
              <p className="copyright">
                Copyright © 2024 Vishv Umiya Foundation. All Rights Reserved.
              </p>
            </div>
          </div>
        )}
      </React.Fragment>
    </>
  );
};

export default connect(null, { setBreadcrumbItems })(ScheduleAttendance);
